import { HatConstants } from "./constants/hat-constants";
import { EventType } from "./constants/event-type-constants";
import { DOMHelper } from "./helpers/dom-helper";

export class Hat {
  prevAnimationAPosY: number = window.scrollY;
  prevPosY: number = window.scrollY;
  marginOfError = 9;

  constructor(public isMobile: Boolean) {}

  init() {
    if (this.isMobile) {
      const hat: Element | null = DOMHelper.querySelector(HatConstants.hatSelector) as Element,
        hatWrapper: HTMLElement | null = DOMHelper.querySelector(HatConstants.harWrapperSelector) as HTMLElement,
        scrollDown: string = hat?.getAttribute(HatConstants.dataScrollDown) || "0",
        scrollUp: string = hat?.getAttribute(HatConstants.dataScrollUp) || "0";
      this.scrollAnimation(hatWrapper, scrollDown, scrollUp);
    }
  }

  scrollAnimation(hatWrapper: HTMLElement, scrollDown: string, scrollUp: string) {
    window.addEventListener(EventType.SCROLL, () => {
        const currentPosition: string = this.prevPosY >= window.scrollY - this.marginOfError ? HatConstants.top : HatConstants.bottom;

        if (currentPosition === HatConstants.bottom && this.prevPosY > Number(scrollDown)) {
          hatWrapper?.classList.add(HatConstants.scrollDownClass);
          this.prevAnimationAPosY = window.scrollY;
        } else if (currentPosition === HatConstants.top && this.prevPosY < this.prevAnimationAPosY - Number(scrollUp)) {
          hatWrapper?.classList.remove(HatConstants.scrollDownClass);
        }

        this.prevPosY = window.scrollY;
      },
      { passive: true }
    );
  }
}
